import React, { useCallback, useRef, useState } from "react";
import { debounce } from "lodash";
import { Input } from "@treelab/panda";

import { IFilterValue } from "../../../../../../types/form-type";
import { getFormattedAutoNumber } from "../../../../../../utils/filter_secondary";

interface IProps {
  name: string;
  value: IFilterValue;
  onChange: (value: { [key: string]: number | null }) => void;
}

const DefaultInput: React.FC<IProps> = ({ name, value, onChange }) => {
  const [localValue, setLocalValue] = useState<number | null>(getFormattedAutoNumber(value.filterString));
  const debouncedOnInputChange = useRef(debounce(onChange || (() => ({})), 150)).current;

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const parseValue = getFormattedAutoNumber(e.target.value);
      setLocalValue(parseValue);
      debouncedOnInputChange({ filterString: parseValue });
    },
    [debouncedOnInputChange, setLocalValue]
  );
  return (
    <Input.Text
      input={{
        name: `${name}`,
        value: localValue || "",
        onChange: handleChange,
      }}
      meta={{}}
    />
  );
};

export default DefaultInput;
